<button mat-icon-button [disabled]="zoningCode?.isDeleting || zoningCode?.isOrphan"
    [class.not-clickable-actions-buttons]="zoningCode?.isDeleting" class="actions-buttons">
    <mat-icon matTooltip="Reindex Zoning Code Process.
        Uses old indexing mechanism based on data offset.
        GAPI response time will increase with increasing of offset value. Recommended for small Zoning Codes."
        (click)="reindexZoningCode($event, 0)" class="actions-mat-icons">
        replay</mat-icon>
</button>